import { useState, useEffect } from "react"

type Props = {
   endpoint: string,
   username: string,
   password: string
}

// function to sign in BMS and get a token
export const signIn = async ({ endpoint, username, password }: Props) => {
   const response = await fetch(`${endpoint}/users/sign_in`, {
      method: 'POST',
      body: JSON.stringify({
         user: {
            username,
            password,
         },
      }),
      headers: {
         'Content-Type': 'application/json',
      },
   });

   const data: { auth_token: string; } = await response.json()

   return data
}


export const useBmsAuth = (props: Props) => {
   // state
   const [token, setToken] = useState(null)
   const [loading, setLoading] = useState(false)
   // lifecycle methods
   useEffect(() => {
      const getToken = async () => {
         if (token || loading) return;
         setLoading(true)
         const data = await signIn(props)
         setToken(data.auth_token)
         setLoading(false)
      }
      getToken()
   }, [])

   return token
}